import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function repeatPasswordValidator(form: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = form.get('password')?.value;
    const repeatPassword = control.value;
    return password === repeatPassword ? null : { 'passwordMismatch': true };
  };
}
